// extracted by mini-css-extract-plugin
export default {"chart":"SMLCardSparkline_chart__MTr-b","flat":"SMLCardSparkline_flat__srK0t"};